export interface Interest {
  id: number
  text: string
}

export interface ClientInterest {
  id: number
  text: string
  itemHighlighted?: boolean
  locked?: boolean
  imageFlagCoordinates?: number
  isWithFlag?: boolean
}

export enum ListInterest {
  countries = 'countries',
  interests = 'interests',
}
